import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Star, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const opts = { withCredentials: true };
const MAX = 5;
const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Region's favorite Drop push messages. {product} is swapped for the product name.
export function SavedWording({ region, productName, initial, title, body, activeId, onPick, top, endpoint = `${API_URL}/api/drop/saved` }) {
  const [saved, setSaved] = useState(initial || []);
  const fill = (t) => t.replaceAll('{product}', productName || 'This product');
  const tokenize = (t) => (productName ? t.replace(new RegExp(escapeRe(productName), 'g'), '{product}') : t);

  const add = async () => {
    try {
      const { data } = await axios.post(`${endpoint}/${region}`, { title: tokenize(title.trim()), body: tokenize(body.trim()) }, opts);
      setSaved(data.saved_messages);
      toast.success('Wording saved');
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || 'Could not save'); }
  };
  const remove = async (id) => {
    try { setSaved((await axios.delete(`${endpoint}/${region}/${id}`, opts)).data.saved_messages); } catch { toast.error('Could not remove'); }
  };

  return (
    <div className="space-y-1.5" data-testid="drop-saved-wording">
      <div className="flex items-center justify-between">
        <p className="text-[#A3C7A8] uppercase text-[10px]">Saved wording · {region.toUpperCase()} · {saved.length}/{MAX}</p>
        <button type="button" onClick={add} disabled={saved.length >= MAX || !title.trim() || !body.trim()}
          className="inline-flex items-center gap-1 text-[10px] uppercase text-[#FFD700] disabled:opacity-40" data-testid="drop-saved-add">
          <Star className="w-3 h-3" /> Save this wording
        </button>
      </div>
      {saved.length === 0 ? <p className="text-[10px] text-[#6B8E73]" data-testid="drop-saved-empty">// None yet. Tip: use {'{product}'} for the product name.</p> : (
        <div className="flex flex-wrap gap-1.5">
          {saved.map((m) => (
            <span key={m.id} className={`inline-flex items-center border text-[11px] max-w-full ${activeId === m.id ? 'border-[#FFD700] text-[#FFD700]' : 'border-[#2A0F3D] text-[#A3C7A8]'}`} data-testid={`drop-saved-${m.id}`}>
              <button type="button" onClick={() => onPick({ id: m.id, title: fill(m.title), body: fill(m.body) })} className="px-2 py-1 truncate max-w-[200px] hover:text-[#FFD700]" title={fill(m.body)} data-testid={`drop-saved-use-${m.id}`}>{fill(m.title)}</button>
              {top?.id === m.id && (
                <span className="px-1.5 py-1 border-l border-[#FFD700]/60 bg-[#FFD700] text-[#050003] text-[9px] font-bold whitespace-nowrap" data-testid="drop-saved-top-badge">
                  TOP PERFORMER · {Math.round(top.rate * 100)}%
                </span>
              )}
              <button type="button" onClick={() => remove(m.id)} className="px-1.5 py-1 border-l border-[#2A0F3D] hover:text-[#FF3B30]" aria-label="Remove saved wording" data-testid={`drop-saved-remove-${m.id}`}><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
